import { CLEAR_ERROR_MESSAGE, SET_ERROR_MESSAGE } from "../actionTypes";

export const showErrorPopup = (errorHeader,errorMessage,isnote) => ({
  type: SET_ERROR_MESSAGE,
  payload: {errorHeader,errorMessage,isnote},
});

export const clearErrorPopup = () => ({
  type: CLEAR_ERROR_MESSAGE,
});